/*
  Scripts specific to CookieBot (https://www.cookiebot.com/) implementation. 

*/

import { domReady } from "../../scripts";

export const showCookieBanner = () => window?.Cookiebot?.show();
let openDetails = false;

/*
  Expands details view in CookieBot panel, with more information on active cookies
*/
export const showCookieBannerDetails = () => {
  openDetails = true;
  window?.Cookiebot?.show();
};


export const attachShowCookieBannerDetailsEvent = () => {
  const showCookieBannerBtns = document.querySelectorAll(
    ".js-show-cookie-banner-details"
  ) as NodeListOf<HTMLButtonElement>;

  if (showCookieBannerBtns.length > 0) {
    showCookieBannerBtns.forEach((btn) =>
      btn.addEventListener("click", () => {
        if (window.Cookiebot) {
          showCookieBannerDetails();
        }
      })
    );
  }

  window.addEventListener("CookiebotOnDialogDisplay", () => {
    if (!openDetails) return; // do nothing unless we triggered it

    const cookieBanner = document.getElementById("CookieBanner");
    const detailsToggle = document.querySelector(
      ".cookiebanner__details-toggle"
    ) as HTMLButtonElement | null;

    if (!cookieBanner || !detailsToggle) return;

    detailsToggle.addEventListener("click", (event) => {
      const isOpen = cookieBanner.classList.contains("is-details-open");

      if (isOpen) {
        // This click is closing the details
        if (window.Cookiebot?.consented || window.Cookiebot?.declined) {
          event.stopImmediatePropagation(); //prevents cookiebot portal eventCookieBannerDetailsClicked function to fire
          window.Cookiebot.hide();
        }
      }
    });

    //Opens cookiebanner in the "details state" when user clicks "handle cookies" in footer
    cookieBanner.classList.add("is-details-open");
    detailsToggle.setAttribute("aria-expanded", "true");
    detailsToggle.textContent = detailsToggle.getAttribute("data-details-close");
    cookieBanner.style.overflowY = "scroll";
    openDetails = false;

  });

};

export type CookieConsentCategories =
  | "necessary"
  | "preferences"
  | "statistics";

// Utility function for checking current consent state by category
export const getCookieConsentByCategory = (category: CookieConsentCategories) =>
  window?.Cookiebot?.consent[category];

// Used by ReadSpeaker to highlight CookieBot preference panel
export const highlightPreferencePanel = () => {
  setTimeout(() => {
    const panel = document.getElementById("cookiebanner-preference-pref");

    if (panel) {
      panel.classList.add("cookiebanner__preference--highlight");
    }
  }, 200);
};

domReady(() => {
    attachShowCookieBannerDetailsEvent();
});
